enum ADMIN_PAGE_KEY {
  /* 首頁 */
  HOME = 'Home',
  /* 服務 */
  SERVICE = 'Service',
  SERVICE_OVERVIEW = 'ServiceOverview',
  SERVICE_DETAIL_CREATE = 'ServiceDetailCreate',
  SERVICE_DETAIL_UPDATE = 'ServiceDetailUpdate',
  /* 專案 */
  PROJECT = 'Project',
  PROJECT_OVERVIEW = 'ProjectOverview',
  PROJECT_DETAIL_CREATE = 'ProjectDetailCreate',
  PROJECT_DETAIL_UPDATE = 'ProjectDetailUpdate',
  /* 聯絡我們 */
  CONTACT = 'Contact',
  /* 使用者管理 */
  ACCOUNT = 'Account',
  ACCOUNT_OVERVIEW = 'AccountOverview',
  ACCOUNT_DETAIL_CREATE = 'AccountDetailCreate',
  ACCOUNT_DETAIL_UPDATE = 'AccountDetailUpdate'
}

export default ADMIN_PAGE_KEY;
